<div class="input-editor-component"
  [ngClass]="{'pristine': pristine, 'valid': (validStatus$ | async), 'invalid': (invalidStatus$ | async), 'disabled': disabled}">
  <div class="input-wrapper">
    <div [formGroup]="formGroup"
      [attr.required]="required">
      <ckeditor [editor]="editor"
        [config]="configEditor"
        [formControlName]="name"
        (ready)="onReady($event)">
      </ckeditor>
    </div>
    <label class="input-editor-label"
      [attr.required]="required"
      [attr.for]="fieldId"
      [attr.label-out]="labelOut ? '' : undefined">{{label}}
    </label>
    @if (dirty) {
      <span class="input-validation fa-stack fa-1x"
        >
        <i class="fas fa-stack-2x fa-circle"
        aria-hidden="true"></i>
        <i class="fal fa-stack-1x"
          [ngClass]="(validStatus$ | async) ? 'fa-check' : 'fa-times'"
        aria-hidden="true"></i>
      </span>
    }
  </div>
  <aa-validation2 [dirty]="dirty"
    [messages]="failures | async">
  </aa-validation2>
</div>
